
<template>
    <div class="reo-cell-box">
        <div
            class="reo-cell"
            :class="{
                'reo-cell_disabled': item.disabled
            }"
            @click="onClick"
        >
            <div class="reo-cell_title">
                <p class="reo-cell_label" :class="item.labelClass">
                    {{ item.title }}
                    <slot name="title"></slot>
                </p>
                <p class="inline_desc" v-if="item.inlineDesc">
                    {{ item.inlineDesc }}
                    <slot name="inline-desc"></slot>
                </p>
            </div>
            <div class="reo-cell_ficon">
                <slot name="foot-icon"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {

    name: 'reo-cell-box',
    methods: {

        onClick () {

            !this.disabled && !!this.link && this.$router.push( this.link );
            this.$emit( 'cell-click', this.item );

        }
    },
    props: {
        link: [String, Object],
        title: [String, Number],
        inlineDesc: [String, Number],
        disabled: {
            type: Boolean,
            default: false
        },
        labelClass: {
            type: Array,
            default: () => []
        }
    },
    created () {

        this.item = {
            link: this.link || '',
            title: this.title || '',
            inlineDesc: this.inlineDesc || '',
            disabled: this.disabled || false,
            labelClass: this.labelClass || []
        };

    },
    data () {

        return {
            item: {}
        };

    }
};
</script>

<style lang="less" scoped>
.reo-cell-box {
    .reo-cell {
        position: relative;
        padding: 0.2rem 0.3rem;
        text-align: left;
        background: #fff;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .reo-cell_title {
            flex: 1;
            color: #333;
            font-size: 0.34rem;
            .reo-cell_label {
                height: 0.48rem;
            }
            .inline_desc {
                font-size: 0.22rem;
                line-height: 1.5;
                padding-top: 0.08rem;
            }
        }
        .reo-cell_ficon {
            color: #9a9dae;
            font-size: 0.2rem;
        }
        &::before {
            content: " ";
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            height: 1px;
            border-top: 1px solid #d9d9d9;
            color: #e1e1e1;
            -webkit-transform-origin: 0 0;
            transform-origin: 0 0;
            -webkit-transform: scaleY(0.5);
            transform: scaleY(0.5);
            left: 0.3rem;
        }
    }
    .reo-cell_disabled {
        .reo-cell_title {
            color: #cccccc;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/cell.vue